<template>
  <div class="app-container">
    <div class="h-100">
      <div class="h-100 no-gutters row">
        <BlockUI v-if="loading"></BlockUI>
        <div class="d-none d-lg-block col-lg-4">
          <div class="slider-light">
            <div class="slick-slider">
              <div>
                <div
                  class="position-relative h-100 d-flex justify-content-center align-items-center bg-plum-plate "
                  tabindex="-1"
                >
                  <div
                    class="slide-img-bg"
                    :style="{ 'background-image': 'url('+require('@/assets/images/originals/abstract2.jpg')+')' }"
                  ></div>
                  <div class="slider-content">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="h-100 d-flex bg-white justify-content-center align-items-center col-md-12 col-lg-8"
        >
          <div class="mx-auto app-login-box col-sm-12 col-md-10 col-lg-9">
            <div class="app-logo"></div>
            <h4 class="mb-0">
              <span class="d-block">Bienvenido,</span>
              <span>Por favor inicia sesión.</span>
            </h4>
            <div class="divider row"></div>
            <div>
              <form  @submit.prevent="submit">
                <div class="form-row">
                  <div class="col-md-6">
                    <div class="position-relative form-group">
                      <label for="documento">Documento</label>
                      <input type="text" inputmode="numeric" name="documento" id="documento" class="form-control" v-model="form.documento" />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="position-relative form-group">
                      <label for="password">Password</label>
                      <input type="password" name="password" id="password" class=form-control v-model="form.password" />
                    </div>
                  </div>
                </div>
                <div class="divider row"></div>
                <div class="d-flex align-items-center">
                  <div class="ml-auto">
                    <button class="btn btn-primary btn-lg">Iniciar sesión</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions } from "vuex";
import BlockUI from '@/components/loaders/BlockUI'
import Swal from "sweetalert2"
// import imagenLogin from '@/assets/images/originals/city.jpg'
export default {
  name: "Login",
  components:{
    BlockUI
  },
  data() {
    return {
      form: {
        documento: "",
        password: ""
      },
      loading: true
    };
  },
  mounted(){
    this.loading = false;
  },
  methods: {
    ...mapActions({
      login: "auth/login"
    }),
    submit() {
      this.loading = true;
      this.login(this.form).then(() => {
        this.$router.push({
          name: "Home"
        });
      })
      .catch(error => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido iniciar sesión`
          });
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>
<style scoped>
.form-group {
  padding: 5px;
}
.form-group label {
  display: block;
}
</style>